import { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { useUserAuth } from '../context/UserAuthContext';
import QuotationLeadDeal from './QuotationLeadDeal';
import { Modal } from 'react-bootstrap';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Link } from 'react-router-dom';

// --- Import all PDFs ---
import WeddingQuotationPDF from './pdf/WeddingQuotationPDF.jsx';
import BirthdayQuotationPDF from './pdf/BirthdayQuotationPDF';
import CorporateQuotationPDF from './pdf/CorporateQuotationPDF';
import AnniversaryQuotationPDF from './pdf/AnniversaryQuotationPDF';
import DestinationWeddingQuotationPdf from './pdf/DestinationWeddingQuotationPdf.jsx';
import InternationalWeddingQuotationPdf from './pdf/InternationalWeddingQuotationPdf.jsx';
import ClientQuotationPdf from './clientQuotation/ClientQuotationPdf.jsx';
import BirthdayClientQuotationPdf from './clientQuotation/BirthdayClientQuotationPdf.jsx';
import AnniversaryClientQuotationPdf from './clientQuotation/AnniversaryClientQuotationPdf.jsx';
import CorporateClientQuotationPdf from './clientQuotation/CorporateClientQuotationPdf.jsx';

const PackageLead = () => {
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const { user, token } = useUserAuth();
  const user_id = user?.uid;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState({ table: true });
  const [myPdf, setMyPdf] = useState(null);
  const [currentMerchant, setCurrentMerchant] = useState(null);
  const [clientQuotationData, setClientQuotationData] = useState(null);
  console.log(clientQuotationData);
  
  const [loadingClientPdf, setLoadingClientPdf] = useState(false);

  // --- Modal states ---
  const [showPdf, setShowPdf] = useState(false);
  const [showClientPdf, setShowClientPdf] = useState(false);

  // --- Fetch current merchant details ---
  useEffect(() => {
    if (!user_id) return;
    const getCurrentMerchant = async () => {
      try {
        const merchantRes = await axios.get(`${base_url}/api/v1/users/id/${user_id}`);
        setCurrentMerchant(merchantRes.data.data);
      } catch (error) {
        console.log("Merchant details fetch error:", error.message);
      }
    };
    getCurrentMerchant();
  }, [user_id]);

  // --- Fetch package leads ---
  const getBookVenueList = async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/package-lead/${user_id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data?.data || []);
    } catch (err) {
      console.log("Error fetching leads:", err);
    } finally {
      setLoading(prev => ({ ...prev, table: false }));
    }
  };

  // --- Fetch client quotation details ---
  const getClientQuotation = async (quotation_id) => {
    try {
      setLoadingClientPdf(true);
      const res = await axios.get(
        `${base_url}/api/v1/quotation/wedding-quotation/get-client_quotation`,
        {
          params: { merchant_id: user_id, quotation_id },
        }
      );
      setClientQuotationData(res.data?.data);
    } catch (err) {
      console.log("Error fetching client quotation:", err);
    } finally {
      setLoadingClientPdf(false);
    }
  };

  // --- Initial load ---
  useEffect(() => {
    if (!user_id) return;
    getBookVenueList();
  }, [user_id]);

  const dealCloseTrigger = () => getBookVenueList();

  // --- Handlers ---
  const handleClosePdf = () => setShowPdf(false);
  const handleCloseClientPdf = () => setShowClientPdf(false);

  const pdfHandler = (item) => {
    setMyPdf(item);
    setShowPdf(true);
  };

  const clientPdfHandler = async (item) => {
    setMyPdf(item);
    await getClientQuotation(item?.quotation_id);
    setShowClientPdf(true);
  };

  // --- PDF Renderer ---
  const renderPdfComponent = () => {
    if (!myPdf) return null;
    switch (myPdf.lead_type) {
      case 'wedding_quotation':
        return <WeddingQuotationPDF pdfData={myPdf} />;
      case 'destination_wedding_quotation':
        return <DestinationWeddingQuotationPdf pdfData={myPdf} />;
      case 'international_wedding_quotation':
        return <InternationalWeddingQuotationPdf pdfData={myPdf} />;
      case 'birthday_quotation':
        return <BirthdayQuotationPDF pdfData={myPdf} />;
      case 'corporate_quotations':
        return <CorporateQuotationPDF pdfData={myPdf} />;
      case 'anniversary_quotation':
        return <AnniversaryQuotationPDF pdfData={myPdf} />;
      default:
        return <div className="text-danger p-3">Unknown quotation type</div>;
    }
  };
  const renderClientComponent = (lead_type) => {
    if (!lead_type) return null;
    switch (lead_type) {
      case 'wedding_quotation':
        return 'wedding';
      case 'destination_wedding_quotation':
        return 'destination';
      case 'international_wedding_quotation':
        return 'international';
      case 'birthday_quotation':
        return 'birthday';
      case 'corporate_quotations':
        return 'corporate';
      case 'anniversary_quotation':
        return 'anniversary';
      default:
        return <div className="text-danger p-3">Unknown quotation type</div>;
    }
  };

  const renderClientdfComponent = () => {
    if (!myPdf) return null;
    switch (myPdf.lead_type) {
      case 'wedding_quotation':
        return <ClientQuotationPdf pdfData={clientQuotationData}
          mob_no_status={false}
          quotation_details={myPdf?.quotation_details}
          business_name={currentMerchant?.business_name} />;
      case 'destination_wedding_quotation':
        return <DestinationWeddingQuotationPdf pdfData={clientQuotationData}
          mob_no_status={false}
          quotation_details={myPdf?.quotation_details}
          business_name={currentMerchant?.business_name} />;
      case 'international_wedding_quotation':
        return <InternationalWeddingQuotationPdf pdfData={clientQuotationData}
          mob_no_status={false}
          quotation_details={myPdf?.quotation_details}
          business_name={currentMerchant?.business_name} />;
      case 'birthday_quotation':
        return <BirthdayClientQuotationPdf pdfData={clientQuotationData}
          mob_no_status={false}
          quotation_details={myPdf?.quotation_details}
          business_name={currentMerchant?.business_name} />;
      case 'corporate_quotations':
        return <CorporateClientQuotationPdf pdfData={clientQuotationData}
          mob_no_status={false}
          quotation_details={myPdf?.quotation_details}
          business_name={currentMerchant?.business_name} />;
      case 'anniversary_quotation':
        return <AnniversaryClientQuotationPdf pdfData={clientQuotationData}
          mob_no_status={false}
          quotation_details={myPdf?.quotation_details}
          business_name={currentMerchant?.business_name} />;
      default:
        return <div className="text-danger p-3">Unknown quotation type</div>;
    }
  };


  if (loading.table) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="container-fluid">

        {/* --- Normal Quotation PDF Modal --- */}
        <Modal show={showPdf} onHide={handleClosePdf} size="lg">
          <Modal.Header closeButton>
            <Modal.Title><h4>Download Quotation PDF</h4></Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            {renderPdfComponent()}
          </Modal.Body>
        </Modal>

        {/* --- Client Quotation PDF Modal --- */}
        <Modal show={showClientPdf} onHide={handleCloseClientPdf} size="lg">
          <Modal.Header closeButton>
            <Modal.Title><h4>Download Client Quotation PDF</h4></Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            {loadingClientPdf ? (
              <div className="d-flex justify-content-center align-items-center p-5">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : clientQuotationData ? (
              <div className="download-link">
                <PDFDownloadLink
                  document={renderClientdfComponent()}
                  fileName={`${myPdf?.quotation_details?.name || 'Client'}-${myPdf?.lead_type}-${clientQuotationData?.quotation_id}.pdf`}
                >
                  <center>
                    <button className="text-light btn btn-sm btn-success m-3">
                      Download Quotation
                    </button>
                  </center>
                </PDFDownloadLink>
              </div>
            ) : (
              <div className="text-center p-3 text-danger">
                Failed to load client quotation data
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* --- Table Section --- */}
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <h2>Package Lead</h2>
              <div className="table-responsive">
                <table className="table table-bordered shadow-sm mt-3" cellPadding={5}>
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Quotation Type</th>
                      <th>Name</th>
                      <th>Event Budget</th>
                      <th>Payment Status</th>
                      <th>Assigned Date</th>
                      <th>Create Quotation</th>
                      <th>Download</th>
                      <th>Deal Closed At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.length > 0 ? (
                      data.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.lead_type}</td>
                          <td>{item.quotation_details?.name}</td>
                          <td>{item.quotation_details?.event_budget}</td>
                          <td>
                            <span className={`badge ${item.payment_status ? 'bg-success' : 'bg-warning'}`}>
                              {item.payment_status ? 'Paid' : 'Pending'}
                            </span>
                          </td>
                          <td>{dayjs(item.created_at).format('DD MMMM, YYYY')}</td>
                          <td>
                            {item?.client_quotation_status ? (
                              <>
                                <Link to={`/dashboard/${renderClientComponent(item?.lead_type)}-client-quotation/${item?.quotation_id}`}>
                                  <button
                                    className="btn-sm btn btn-primary m-1">Update</button>
                                </Link>
                                <button
                                  className="btn-sm btn btn-primary m-1"
                                  onClick={() => clientPdfHandler(item)}
                                >
                                  Download
                                </button>
                              </>
                            ) : (
                              <Link to={`/dashboard/${renderClientComponent(item?.lead_type)}-client-quotation/${item?.quotation_details?.id}`}>
                                <button className="btn btn-success text-light btn-sm">Create</button>
                              </Link>
                            )}
                          </td>
                          <td>
                            <button className="btn btn-success btn-sm" onClick={() => pdfHandler(item)}>
                              Download
                            </button>
                          </td>
                          <td>
                            <QuotationLeadDeal dealCloseTrigger={dealCloseTrigger} item={item} />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">No data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageLead;